import { render, staticRenderFns } from "./InspectDetail.vue?vue&type=template&id=7ae474c4&scoped=true"
import script from "./InspectDetail.vue?vue&type=script&lang=js"
export * from "./InspectDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectDetail.vue?vue&type=style&index=0&id=7ae474c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae474c4",
  null
  
)

export default component.exports